export default "__VITE_ASSET__DmXFb2lf__"